<template>
  <v-form
    ref="setProjectThumbnail"
    v-model="isFormValid"
    class="set-project-thumbnail"
    @submit.prevent="submitForm"
  >
    <video
      ref="videoPlayer"
      width="100%"
      controls
    >
      <source :src="file.url">
    </video>
    <label class="input-label mt-4">Wybierz sekundę:</label>
    <v-text-field
      v-model.number="chosenSecond"
      :rules="[rules.required, rules.lowerThan(videoDuration+1)]"
      type="number"
      min="0"
      :max="videoDuration"
      placeholder="Wybierz sekundę"
      :menu-props="{ 'offset-y': true }"
      v-bind="props.validatedField"
    />
    <v-btn
      class="custom-submit-button mt-2"
      color="primary"
      type="submit"
      :disabled="!isFormValid"
      :loading="isProcessing"
    >
      Ustaw jako miniaturkę
    </v-btn>
  </v-form>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import props from '@/helpers/componentsProps.js'
import rules from '@/helpers/validators.js'

export default {
  props: {
    file: {
      type: Object,
      required: true
    },
  },

  data: ()=>({
    isFormValid:true,
    videoDuration: 1,
    chosenSecond: 1,
    props,
    rules,
  }),

  computed:{
    ...mapState('project',[
      'project',
      'isProcessing'
    ]),
  },

  mounted() {
    const { videoPlayer } = this.$refs

    videoPlayer.addEventListener('loadedmetadata', () => {
      this.videoDuration = Math.floor(videoPlayer.duration);
    });
  },

  methods: {
    ...mapActions('project', [
      'selectThumbnail'
    ]),
    submitForm() {
      this.selectThumbnail({type: 'movie', id: this.file.id, screenshotTime: this.chosenSecond})
    }
  }
}
</script>
